import { Route } from "@angular/router";
import { LoginPage } from "./login.page";

export const LoginRouter: Route[] = [
  { path: 'login', component: LoginPage }
];
